import React from "react";
import {
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
} from "@mui/material";

const StandardCakeColors = ({ formData, setFormData, colorOptions }) => {
  const handleChange = (value) => {
    setFormData((prev) => ({
      ...prev,
      colors: value,
    }));
  };

  return (
    <>
      <Typography sx={{ mt: 2, mb: 1 }}>Colors</Typography>
      <FormControl fullWidth>
        <InputLabel>Select Colors</InputLabel>
        <Select
          multiple
          value={formData.colors}
          onChange={(e) => handleChange(e.target.value)}
          renderValue={(selected) => selected.join(", ")}>
          {colorOptions.map((color) => (
            <MenuItem key={color} value={color}>
              <Checkbox checked={formData.colors.includes(color)} />
              <ListItemText primary={color} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </>
  );
};

export default StandardCakeColors;
